"use client";
import { performAuthenticatedCall } from "lib/utils";
import { observer } from "mobx-react-lite";
import { useParams, useRouter } from "next/navigation";
import user from "observables/user";
import { useEffect } from "react";
import { Users } from "@prisma/client";
import dishPreparation from "../../../animations/dish-preparation.json";
import Lottie from "lottie-react";

const Page = () => {
  const params = useParams();
  const { replace } = useRouter();

  useEffect(() => {
    const initUser = async () => {
      user.setIsLoading(true);
      const result = await performAuthenticatedCall<
        Users & { defaultStore: { slug: string } }
      >(`/users/current`, "", "GET", undefined);

      user.setValue(result);
      user.setIsLoading(false);

      if (!user.defaultStoreSlug) {
        replace("/no-store");
        return;
      }

      if (typeof params["redirect-sub-route"] !== "string") {
        replace(
          ["/s", user.defaultStoreSlug, ...params["redirect-sub-route"]].join(
            "/"
          )
        );
      }
    };

    initUser();
  }, []);

  return (
    <div className="flex justify-center items-center">
      <div className="w-1/3 h-1/3">
        <Lottie animationData={dishPreparation} loop={true} />
      </div>
    </div>
  );
};

export default observer(Page);
